import { useState } from 'react';

interface StepData {
  [key: string]: any;
}

export type TWizardReturn<T extends StepData> = {
  step: keyof T;
  // steps: (keyof T)[];
  // isLastStep: boolean;
  // isFirstStep: boolean;
  goToStep: (step: keyof T) => void;
  nextStep: () => void;
  previousStep: () => void;
  data: T;
  updateData: (step: keyof T, newData: Partial<T[keyof T]>) => void;
};

export const useWizard = <T extends StepData>(initialSteps: (keyof T)[], initialData: T): TWizardReturn<T> => {
  const [stepIndex, setStepIndex] = useState(0);
  const [wizardData, setWizardData] = useState<T>(initialData);

  const steps = initialSteps;
  const step = steps[stepIndex];

  const isLastStep = stepIndex === steps.length - 1;
  const isFirstStep = stepIndex === 0;

  const goToStep = (step: keyof T) => {
    const index = steps.indexOf(step);
    if (index !== -1) {
      setStepIndex(index);
    }
  };

  const nextStep = () => {
    if (!isLastStep) {
      setStepIndex((prevIndex) => prevIndex + 1);
    }
  };

  const previousStep = () => {
    if (!isFirstStep) {
      setStepIndex((prevIndex) => prevIndex - 1);
    }
  };

  const updateData = (step: keyof T, newData: Partial<T[keyof T]>) => {
    setWizardData((prevData) => ({ ...prevData, [step]: newData }));
  };

  return {
    step,
    goToStep,
    nextStep,
    previousStep,
    data: wizardData,
    updateData,
  };
};
